<template>
	<div style="width: 92%;margin: 0 auto;" v-if="items">
		<div style="height: 10px;"></div>
		<div style="height: 26px;display: flex;justify-content: space-between;">
			<el-button slot="reference" type="success" size="mini" @click="deviceSelectVisible=true" v-show="devices&&devices.length>0"
			 round>更换设备</el-button>
			<!-- <img src="../assets/logo.jpg" style="width: 50%;height: auto;" alt=""> -->
		</div>
		<div style="height: 50px;">
		</div>
		<div style="font-size: 24px;line-height: 24px;height: 24px;">
			{{device.name}}
		</div>
		<div style="height: 10px;"></div>
		<div style="height: 20px;line-height: 20px;font-size: 20px;text-align: center;">
			空气质量实时监测
		</div>
		<v-chart :options="gauge" style="height: 280px;" v-if="gauge!=null"></v-chart>
		<el-row :gutter="10">
			<el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" v-for="item in items" :key="item.id">
				<div style="height: 80px;width: 100%;" v-if="item" @click="selectItemId=item.id">
					<div style="height: 60px;display: flex;padding: 5px;border-radius: 5px;background-color: #F7F7F7;">
						<div style="width: 30%;display: flex;justify-content: center;">
							<img :src="itemLogoUrl+item.id+'.svg'" style="width: 60%;" alt="">
						</div>
						<div style="width: 70%;">
							<div style="text-align: center;height: 20px;font-size: 12px;color: gray;">
								{{item?item.title+'（'+item.unit+'）':''}}
							</div>
							<div style="height: 40px;line-height: 40px;text-align: center;">{{item&&item.realData?item.realData[0]:''}}</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
		<div style="height: 20px;"></div>
		<v-chart :options="curve" v-if="curve!=null" style="height: 400px;"></v-chart>
		<el-dialog title="请选择设备" :visible.sync="deviceSelectVisible" width="95%" center>
			<el-table :data="devices" style="width: 100%;">
				<el-table-column prop="id" label="设备ID">
				</el-table-column>
				<el-table-column prop="name" label="设备名称">
				</el-table-column>
				<el-table-column prop="address" label="安装地址">
				</el-table-column>
				<el-table-column label="">
					<template slot-scope="scope">
						<el-button size="mini" @click="deviceId = scope.row.id;deviceSelectVisible=false;">选择</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		name: 'HelloWorld',
		props: {
			msg: String
		},
		data: function() {
			return {
				selectItemId: 'PM25',
				items: [],
				deviceId: '61342996',
				apiAddress: 'http://122.112.234.240:9007',
				customerId: '8888',
				devices: [],
				time: ['start', 'end'],
				publicPath: process.env.BASE_URL,
				device: {},
				//appid
				id: '',
				openid: '',
				apiAddress2: 'http://indoor.lannovo.com',
				deviceSelectVisible: false,
				loading: null,
				itemLogoUrl: 'http://122.112.234.240:11111/itemlogo/'
			}
		},
		computed: {
			curve: function() {
				let itemId = this.selectItemId;
				let item;
				if (this.items) {
					item = this.items.find(item => item.id == itemId)
				}
				if (item && item.historyData && item.historyData.length > 0) {
					let unit = item.unit;
					let name = item.title;
					let yValues = [];
					let xValues = [];
					let historyData = item.historyData;
					if (historyData && historyData.length > 0) {
						for (let i = 0; i < historyData.length; i++) {
							let data = historyData[i];
							if (data) {
								xValues.push(data[2]);
								yValues.push(data[0]);
							}
						}
					}
					return {
						title: {
							text: '过去七天历史数据 ' + name + '(' + unit + ')',
							left: 'left',
							textStyle: {
								fontSize: 14
							}
						},
						xAxis: {
							type: 'category',
							boundaryGap: false,
							data: xValues,
							axisLabel: {
								formatter: function(text) {
									return text.substring(4, 6) + '/' + text.substring(6, 8) + '\n' + text.substring(0, 4);
								}
							}
						},
						yAxis: {
							type: 'value'
						},
						series: [{
							data: yValues,
							type: 'line',
							smooth: true,
							areaStyle: {
								color: 'rgba(116,249,232,0.8)'
							},
							lineStyle: {
								color: '#74f9e8',
							},
							symbol: 'none',
						}],
						grid: {
							left: '12%',
							right: '5%',
							top: '8%'
						}
					}
				} else {
					return null;
				}
			},
			gauge: function() {
				if (this.items && this.items.length > 0) {
					let item = this.items.find(item => item.id == this.selectItemId);
					if(!item){
						return null;
					}
					let realData = item.realData;
					let unit = item.unit;
					let name = item.title;
					let levels = item.level;
					let value;
					if (realData && realData.length > 0) {
						value = realData[0];
					}
					let min = levels[0][0];
					let max = levels[levels.length - 1][1];
					let colors = [];
					for (let i = 0; i < levels.length; i++) {
						let level = levels[i];
						if (level) {
							let rate = (level[1] - min) / (max - min);
							colors.push([rate, '#' + level[3]]);
						}
					}
					let options = {
						title: {
							text: '实时数据',
							left: 'center',
							bottom: '10%',
							textStyle: {
								fontSize: 14,
							}
						},
						tooltip: {
							formatter: '{b} : {c} ' + unit
						},
						series: [{
							name: name,
							// name: '业务指标',
							type: 'gauge',
							// detail: {formatter: '{value} μg/m³'},
							data: [{
								value: value,
								name: name
							}],
							min: min, // 最小的数据值,默认 0 。映射到 minAngle。
							max: max,
							splitNumber: 10,
							axisLine: {
								lineStyle: {
									color: colors,
									width: 10,
								}
							},
							splitLine: { // 分隔线
								length: 10, // 属性length控制线长
								lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
									color: 'auto'
								}
							},
							axisTick: { // 坐标轴小标记
								length: 5, // 属性length控制线长
								lineStyle: { // 属性lineStyle控制线条样式
									color: 'auto'
								}
							},
							detail: {
								offsetCenter: [0, "40%"], //设置仪表盘下方显示内容位置
								formatter: '{value} ' + unit,
								textStyle: {
									fontSize: 16
								},
							},
							title: { //设置仪表盘中间显示文字样式
								textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
									fontSize: 18,
									fontFamily: 'Microsoft YaHei'
								}
							},
							axisLabel: { //文字样式（及“10”、“20”等文字样式）
								// color : "white",
								distance: 5, //文字离表盘的距离
								fontSize: 12
							},
							radius: '80%',
							pointer: {
								width: 3,
								length: '65%'
							},
						}],
						grid: {
							top: 'top'
						}
					};
					// console.log('gauge', options);
					return options;
				} else {
					return null;
				}
			},
			// url_getDeviceItems: function() {
			// 	return this.apiAddress + '/device/items/' + this.deviceId;
			// },
			url_getHistoryData: function() {
				return this.apiAddress + '/monitor/device/day/' + this.deviceId + '/all/' + this.startTime + '/' + this.endTime;
			},
			url_getRealData: function() {
				return this.apiAddress + '/monitor/devices/real/' + this.deviceId + '/all/0';
			},
			url_getDeviceInfo: function() {
				return this.apiAddress + '/device/info/' + this.deviceId;
			},
			url_getCustomerId: function() {
				return this.apiAddress2 + '/wechat/uuid/' + this.openid;
			},
			url_setCustomerId: function() {
				return this.apiAddress2 + '/wechat/setuuid';
			},
			url_getDevices: function() {
				return this.apiAddress + '/device/list/' + this.customerId;
			},
			/* PM25: function(){
				console.log('this.items.PM25',this.items.PM25);
				return this.items.PM25;
			} */
		},
		methods: {
			url_getDeviceItems: function(deviceId) {
				if (deviceId) {
					return this.apiAddress + '/device/items/' + deviceId;
				} else {
					return null;
				}
			},
			getItems: function() {
				return this.axios.get(this.url_getDeviceItems(this.deviceId)).then((mes) => {
					if (mes.data && mes.status == 200) {
						let items = mes.data;
						if (items && items.length > 0) {
							items.forEach(item => {
								if (item && item.id && item.level && item.level.length > 0) {
									item.level.sort((lev1, lev2) => {
										return lev1[0] - lev2[0];
									});
								}
							});
							this.items = items;
						}
					}
				})
			},
			getDeviceItemData: function(deviceId, itemId) {
				let device = this.getDevice(deviceId);
				if (device) {
					let datas = device.datas;
					if (datas) {
						let data = datas.find(data => data.item && data.item.id == itemId);
						return data;
					}
				}
			},
			// 获取设备信息
			getDevices: function() {
				return new Promise((resolve, reject) => {
					this.axios.get(this.url_getDevices).then((mes) => {
						if (mes && mes.status == 200 && mes.data && mes.data.code == 200) {
							let devices = mes.data.data;
							if (devices && devices.length > 0) {
								for (let i = 0; i < devices.length; i++) {
									let device = devices[i];
									if (device) {
										let deviceId = device.device_id;
										this.devices.push({
											id: deviceId,
											name: device.device_name,
											address: device.address,
											type: device.device_type,
											status: device.is_online == '在线' ? 'online' : 'offline',
										});
									}
								}
								console.log('devices', this.devices);
								return resolve();
							}
						}
						return reject();
					}).catch(e => reject(e));
				});
			},
			refleshTime: function() {
				let now = this.$moment();
				this.endTime = now.format('YYYYMMDD');
				this.startTime = now.subtract(8, 'days').format('YYYYMMDD');
			},
			getRealData: function() {
				return this.axios.get(this.url_getRealData).then(mes => {
					if (mes && mes.status == 200 && mes.data && mes.data.status == 200) {
						let datas = mes.data.data;
						if (datas && datas.length > 0) {
							let data = datas[0];
							if (data) {
								let items = this.items;
								for (let i = 0; i < items.length; i++) {
									let item = items[i];
									let itemId = item.id;
									let value = data[itemId];
									if (value != null) {
										let level = this.getLevel(itemId, value);
										if (item) {
											this.$set(item, 'realData', [value, level]);
										}
									}
								}
							}
						}
					}
				})
			},
			getHistoryData: function() {
				return this.axios.get(this.url_getHistoryData).then(mes => {
					if (mes && mes.status == 200 && mes.data && mes.data.status == 200) {
						let datas = mes.data.data;
						if (datas && datas.length > 0) {
							let items = this.items;
							for (let i = 0; i < items.length; i++) {
								let item = items[i];
								let itemId = item.id;
								if (item) {
									let values = [];
									datas.forEach(data => {
										let value = data[itemId];
										let level = this.getLevel(itemId, value);
										let time = data.idx;
										values.push([value, level, time]);
									})
									if (values && values.length > 0) {
										values.sort((v1, v2) => {
											let time1 = parseInt(v1[2]);
											let time2 = parseInt(v2[2]);
											return time1 - time2;
										});
									}
									this.$set(item, 'historyData', values);
									console.log('this.items', this.items);
								}
							}
						}
					}
				})
			},
			getLevel: function(itemId, value) {
				let item;
				if (this.items) {
					item = this.items.find(item => item.id == itemId);
				}
				if (item && item.level && item.level.length > 0) {
					let levels = item.level;
					return levels.find(level => {
						if (level && value > level[0] && value <= level[1]) {
							return level;
						}
					});

				}
			},
			getQueryVariable: function(variable) {
				let query = window.location.search.substring(1);
				let vars = query.split("&");
				for (let i = 0; i < vars.length; i++) {
					let pair = vars[i].split("=");
					if (pair[0] == variable) {
						return pair[1];
					}
				}
				return (false);
			},
			getDevice: function() {
				return this.axios.get(this.url_getDeviceInfo).then(mes => {
					if (mes && mes.status == 200 && mes.data && mes.data.data) {
						this.device.name = mes.data.data.device_name ? mes.data.data.device_name : mes.data.data.device_id;
					}
				});
			},
			getCustomerId: function() {
				let openid = this.getQueryVariable('openid');
				let uuid = this.getQueryVariable('uuid');
				return new Promise((resolve, reject) => {
					if (openid) {
						this.openid = openid;
						if (uuid) {
							this.customerId = uuid;
							let data = {
								openid: openid,
								uuid: uuid
							};
							this.axios({
								url: this.url_setCustomerId,
								method: 'post',
								data: JSON.stringify(data),
								headers: {
									'Content-Type': 'text/plain'
								}
							}).then(res => {
								if (res && res.data && res.data.status == 200) {
									return resolve();
								} else {
									return reject();
								}
							}).catch(e => reject());
						} else {
							this.$axios.get(this.url_getCustomerId).then(res => {
								if (res && res.data && res.data.uuid) {
									this.customerId = res.data.uuid;
									return resolve();
								} else {
									return reject();
								}
							}).catch(e => reject())
						}
					}
				});
			},
			init: function() {
				if (!this.loading) {
					this.loading = this.$loading({
						lock: true,
						text: '加载中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				}
				this.refleshTime();
				setInterval(() => {
					this.refleshTime()
				}, 30 * 60 * 1000);
				this.getCustomerId().then(() => {
					this.getDevices().then(() => {
						if (this.devices && this.devices[0]) {
							this.deviceId = this.devices[0].id;
						}
						this.initDevice();
					});
				}).catch(() => {
					if (this.loading) {
						this.loading.close();
						this.loading = null;
					}
					this.$message({
						type: 'warning ',
						message: "无法获取用户,请先扫码绑定用户"
					});
				});
			},
			initDevice: function() {
				if (!this.loading) {
					this.loading = this.$loading({
						lock: true,
						text: '加载中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				}
				if (this.deviceId) {
					let device = this.getDeviceById(this.deviceId);
					if (device) {
						this.device = device;
					}
					this.getItems().then(() => {
						this.selectItemId = this.items[0].id;
						this.getRealData();
					}).then(() => this.getHistoryData()).then(() => {
						if (this.loading) {
							this.loading.close();
							this.loading = null;
						}
					});
					setInterval(() => {
						this.getRealData();
					}, 30 * 1000);
					setInterval(() => {
						this.getHistoryData();
					}, 30 * 60 * 1000)
				}
			},
			getDeviceById: function(deviceId) {
				let devices = this.devices;
				if (deviceId && devices) {
					let device = devices.find(device => device.id == deviceId);
					if (device) {
						return device;
					}
				} else {
					return null;
				}
			}
		},
		mounted: function() {
			this.init();
		},
		watch: {
			deviceId: function() {
				this.initDevice();
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.echarts {
		width: 100%;
		height: 100%;
	}
</style>
